import { Frequency, MedicineCategory, Duration } from '../store/types/prescription';
import { GET_DRUG_SEARCH } from './constants';
import { HXNG_MAPPED, HXNG_STATUS } from './fetchDrugsAndLabTestsStatus';
import fetchWithRefresh from './fetchWithRefresh';

export interface UnCodedMedications {
    name: string;
    id: string;
    form?: string;
    quantity?: string;
    unit?: string;
    uid?: string;
    generic_name?: string;
    generic_id?: string;
    manufacturer_name?: string;
    manufacturer_id?: string;
    frequency?: Frequency;
    duration?: Duration;
}

export interface CodedMedications {
    id: string;
    name: string;
    manufacturer_name?: string;
    product_type?: string;
    product_sku?: string;
    generic_name?: string;
    generic_id?: string;
    dosage: {
        unit: string;
        unit_val: string;
        dosage: string;
        dosage_form: string;
        df_id: string;
        days: string;
        food: string;
    };
    soa: boolean;
    drug_name_match: boolean;
    non_medicine_status?: MedicineCategory;
    hxng_mapped?: HXNG_MAPPED;
    hxng_status?: HXNG_STATUS;
}

export default (
    body: {
        medications: UnCodedMedications[];
    },
    from: string,
): Promise<{ [k: string]: CodedMedications[] }> =>
    fetchWithRefresh(GET_DRUG_SEARCH(from), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then((res) => res.json());
